import { Search, Sun, Moon, Bell, Plus } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { Button } from "./ui/button";

export function Topbar({ title, subtitle, action }) {
  const { theme, toggle } = useTheme();
  return (
    <header
      data-testid="app-topbar"
      className="sticky top-0 z-20 flex items-center justify-between gap-4 border-b border-slate-200 dark:border-slate-800 bg-white/95 dark:bg-slate-900/95 backdrop-blur pl-16 md:pl-6 pr-6 lg:px-8 py-4"
    >
      <div className="min-w-0">
        <h1
          className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-slate-900 dark:text-slate-50 truncate"
          data-testid="topbar-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5 truncate">
            {subtitle}
          </p>
        )}
      </div>

      <div className="flex items-center gap-2 md:gap-3 shrink-0">
        <div className="hidden lg:flex items-center gap-2 rounded-sm border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 px-3 py-1.5 w-64">
          <Search size={14} className="text-slate-400" />
          <input
            data-testid="topbar-search-input"
            className="bg-transparent outline-none text-sm text-slate-700 dark:text-slate-200 placeholder:text-slate-400 w-full"
            placeholder="Search properties, docs…"
          />
        </div>

        <button
          data-testid="theme-toggle-btn"
          onClick={toggle}
          aria-label="Toggle theme"
          className="h-9 w-9 flex items-center justify-center rounded-sm border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/60 transition-colors"
        >
          {theme === "dark" ? <Sun size={15} strokeWidth={1.75} /> : <Moon size={15} strokeWidth={1.75} />}
        </button>

        <button
          data-testid="topbar-notifications-btn"
          className="h-9 w-9 flex items-center justify-center rounded-sm border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/60 transition-colors"
          aria-label="Notifications"
        >
          <Bell size={15} strokeWidth={1.75} />
        </button>

        {action}
      </div>
    </header>
  );
}

export function AddPropertyButton({ onClick }) {
  return (
    <Button
      data-testid="topbar-add-property-btn"
      onClick={onClick}
      className="h-9 gap-1.5 bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-white text-white rounded-sm"
    >
      <Plus size={15} strokeWidth={2} />
      Add property
    </Button>
  );
}
